import * as React from 'react';

class AdminDashboard extends React.Component<any, any> {
    public render() {
        return (
            <>
                <h4>Admin</h4>
            </>
        );
    }
}

export default AdminDashboard;
